/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 14:18:07
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-06 21:51:33
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC/index.tsx
 */
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC';

import { get } from 'lodash';
import { SalesChannelContentStatus } from '@/src/types/common/common';
import {
  salesChannelResourceNameGenerator,
  isUserValid,
} from 'src/tools/getUserInfo';
import {
  EnumCategory,
  EnumSubCategory,
  EnumOperation,
  EPermissionSource,
} from 'src/types/common/resources';
const _BasicPageHOC = (Component: any, obj: any) => {
  return BasicPageHOC(Component, {
    ...obj,
    canSaveGenerate: (salesChannel) => {
      const status = get(salesChannel, 'status');
      const uuid = get(salesChannel, 'salesChannelUuid');
      //return false;
      if (
        status === SalesChannelContentStatus.Live ||
        status === SalesChannelContentStatus.Scheduled
      ) {
        return isUserValid({
          source: EPermissionSource.salesChannel,
          resourcesGroup: [
            salesChannelResourceNameGenerator({
              category: EnumCategory.SalesChannelContent,
              subCategory: EnumSubCategory.ChannelContent,
              operation:
                EnumOperation.create_duplicate_edit_live_content_version,
              uuid,
            }),
          ],
        });
      }
      if (status === SalesChannelContentStatus.Draft) {
        return isUserValid({
          source: EPermissionSource.salesChannel,
          resourcesGroup: [
            salesChannelResourceNameGenerator({
              category: EnumCategory.SalesChannelContent,
              subCategory: EnumSubCategory.ChannelContent,
              operation:
                EnumOperation.create_duplicate_edit_draft_content_version,
              uuid,
            }),
          ],
        });
      }
      return false;
    },
  });
};

export default _BasicPageHOC;
